import {useFormContext, Controller} from "react-hook-form";
import {ProcessTextField} from "views/ProcessDetails/refactor/components";
import {Process} from "views/ProcessDetails/refactor/types/process.types";

type Props = {
  index: number;
  disabled: boolean;
};
const VoyagePlacePickupField = (props: Props) => {
  const {index, disabled} = props;
  const {control} = useFormContext<Process>();
  return (
    <Controller
      name={
        `boarding.voyages.${index}.placePickup` as `boarding.voyages.0.placePickup`
      }
      control={control}
      render={({field: {onChange, value}}) => (
        <ProcessTextField
          name={`boarding.voyages.${index}.placePickup`}
          placeholder="Local de coleta"
          value={value ?? ""}
          onChange={onChange}
          size="small"
          disabled={disabled}
          fullWidth
          label="Local de coleta"
        />
      )}
    />
  );
};

export default VoyagePlacePickupField;
